import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import MainSectionLayout from '@Components/MainSectionLayout';
import SMTPSettingsVerification from '@Containers/Emails/SMTPSettingsVerification';
import { BaseAlertProps } from '@Typings/global.types';

const SMTPSettingsVerificationPage: FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();
  const [alertState, setAlertState] = useState<BaseAlertProps>({
    openAlert: false,
  });
  const heading = t('Email.SMTP Settings');

  return (
    <MainSectionLayout
      heading={heading}
      alertState={alertState}
      filters={<SMTPSettingsVerification setAlertState={setAlertState} />}
    />
  );
};

export default SMTPSettingsVerificationPage;
